import { useState } from 'react';

import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';

import { useNavigate } from 'react-router-dom';

export const CustomForm = ({pname, pid, label, submit}) => {
  const navigate = useNavigate();
  const [ name, setName ] = useState(pname || '')
  const [ id, setId ] = useState(pid || '')

  const onSubmit = (event) => {
    event.preventDefault();
    submit(id, name);
  }
  
  return (
    <Box
      onSubmit={onSubmit}
      component="form"
      sx={{
        '& > :not(style)': { m: 1, width: '25ch' },
      }}
      noValidate
      sx={{ flexGrow: 1 }}
      autoComplete="off"
    >
      <Grid container spacing={2}>
        <Grid md={12} display="flex" justifyContent="center" alignItems="center">
          <FormControl variant="standard">
            <InputLabel htmlFor="name">Name</InputLabel>
            <Input id="name" value={name} onChange={(event) => setName(event.target.value)}/>
          </FormControl>          
        </Grid>
        <Grid md={12} display="flex" justifyContent="center" alignItems="center">
          <FormControl variant="standard">
            <InputLabel htmlFor="id">ID</InputLabel>
            <Input id="id" value={id} onChange={(event) => setId(event.target.value)}/>
          </FormControl>                
        </Grid>
        <Grid md={12} display="flex" justifyContent="center" alignItems="center">
          <Button sx={{mr: 2}} color="success" variant="contained" type="submit"> { label } </Button>
          <Button sx={{ml: 2}} color="warning" variant="contained" type="button" onClick={() => navigate('/')}> Cancel</Button>
        </Grid>
      </Grid>      
    </Box>    
  )
}
